import * as ActionTypes from "constants-lib/actionTypes"

export const cancelPaymentDetails = () => (dispatch) => {
  dispatch({
    type: ActionTypes.GET_MY_WM_PAYMENT_CANCEL_TRANSACTION,
  })
}
